<div class="fixed inset-0 employee-background -z-10 bg-gray-100"></div>
<div class="fixed inset-x-0 top-0 h-14 z-10 inline-flex select-none bg-white/80 backdrop-blur-md border-b border-gray-200/60 shadow-sm">
  <a (click)="sidebar = !sidebar"
     class="lg:hidden standalone:hidden place-self-center ml-4 text-lg mr-auto inline-flex gap-x-2 p-2 rounded-lg text-gray-600 hover:bg-gray-100/80">
    <svg height="22" viewBox="0 0 24 24" width="22" xmlns="http://www.w3.org/2000/svg">
      <path d="M3 18v-2h18v2zm0-5v-2h18v2zm0-5V6h18v2z"/>
    </svg>
    <span class="sr-only">Menü</span>
  </a>
  <!-- „CheqMe: <Name>" used to sit here. It has moved into the head of the sidebar drawer (#602), where it
       still links to Mein Profil and now carries the current Arbeitsbereich underneath it — the bar had room
       for one of the two, and on a phone the workspace is the one that has to be reachable from every screen.
       The context chip takes its place, CENTRED on the bar (see the element below); from `sm` upwards it is
       not in the DOM at all and this bar is the avatar alone, because the floating pill in
       `app.component.html` is what switches contexts at those widths. -->
  <div class="inline-flex min-w-0 items-center standalone:flex-row-reverse lg:flex-row-reverse">
    <img [routerLink]="EmployeePanelRoutes.Dashboard" alt="company logo"
         class="mr-6 rounded-full place-self-center h-9 ml-4 lg:!ml-6 border border-gray-200 shadow-sm cursor-pointer"
         src="assets/images/icon.png">
  </div>
  <!-- Centred on the BAR, not laid out between the burger and the avatar (#602). The two ends of this bar are
       different widths — a menu icon on one side, a round avatar with its own margins on the other — so a chip
       placed in the flow lands wherever they leave room rather than in the middle. `left-1/2 -translate-x-1/2`
       is independent of both, and the max width stops it ever reaching either one (the tenant name truncates
       instead). Centred with a full-width flex overlay rather than `left-1/2 -translate-x-1/2`: a transform
       becomes the containing block for every `position: fixed` descendant, and the chip's drawer is fixed —
       it would have been sized against this box instead of the viewport. `pointer-events-none` keeps the
       overlay off the burger and the avatar underneath it.
       No `relative` on the bar — and it must not be added: `position` is ONE property, so Tailwind's
       `.relative` (emitted after `.fixed`) would win and this bar would stop being fixed. A `fixed` element is
       already a containing block for its absolutely positioned descendants. And no `sm:hidden` either: the
       breakpoint belongs to `ViewportService.isBelowSm()` inside the component, and a class here would be a
       second source of truth for one fact. Above `sm` this box has no child and collapses to 0x0. -->
  <div class="pointer-events-none absolute inset-0 z-[1] flex items-center justify-center">
    <div class="pointer-events-auto max-w-[46%]">
      <auth-context-switcher placement="header"/>
    </div>
  </div>
</div>
<div class="fixed right-0 top-0 h-20 inline-flex z-10 select-none">
</div>

<!-- Gate warning strip: persistent while the session is time-boxed by ANY gate. It carries ONE of three
     messages — "Formular ausstehend" (a newly assigned form still inside its 14-day Frist, nothing wrong yet),
     "Prüfung fällig" (a flagged or expired submission) or "Verknüpfung ausstehend" (a required contact channel
     inside its Frist, #558) — each with its own deadline and its own destination.
     Exactly one strip, ever: AlertBannerComponent.TopOffsetClass encodes this chrome as a single top-24. The
     kind is chosen in ngOnInit by the soonest deadline, so a second gate never stacks a second row. -->
@if (showsBanner) {
  @let kind = banner().kind;
  @let pending = kind === 'pending';
  @let contact = kind === 'contact';
  <a [routerLink]="contact ? ['/ep', EmployeePanelRoutes.Contacts]
       : (pending ? ['/' + AppRoutes.FormsRequired] : ['/ep', EmployeePanelRoutes.Submissions])"
     [attr.data-test]="'gate-banner-' + kind"
     class="fixed top-14 inset-x-0 lg:left-64 z-[9] h-10 flex items-center gap-2 px-4 sm:px-6 bg-yellow-50 hover:bg-yellow-100 border-b border-yellow-100 text-yellow-700 transition-colors">
    @if (contact) {
      <!-- A chat bubble, matching the sidebar entry and the lockout screen: this is about a messenger contact,
           not about a document. Like the pending branch it is a to-do, not a fault. -->
      <svg class="h-4 w-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"
           xmlns="http://www.w3.org/2000/svg">
        <path d="M8 10h8m-8 4h5m7-2a9 9 0 01-9 9 8.96 8.96 0 01-4.03-.95L3 21l1.02-3.86A8.96 8.96 0 013 12a9 9 0 1118 0z"
              stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
      </svg>
      <span class="text-xs sm:text-sm font-semibold truncate">
        Verknüpfung ausstehend@if (banner().deadline) {<span> · einzurichten bis {{ banner().deadline | date:'dd.MM.yyyy' }}</span>}
      </span>
    } @else if (pending) {
      <!-- A document, not a warning triangle: an open Frist is a to-do, not a fault. -->
      <svg class="h-4 w-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"
           xmlns="http://www.w3.org/2000/svg">
        <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
      </svg>
      <span class="text-xs sm:text-sm font-semibold truncate">
        Formular ausstehend@if (banner().deadline) {<span> · auszufüllen bis {{ banner().deadline | date:'dd.MM.yyyy' }}</span>}
      </span>
    } @else {
      <svg class="h-4 w-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"
           xmlns="http://www.w3.org/2000/svg">
        <path d="M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
              stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8"/>
      </svg>
      <!-- The explaining clause is desktop-only: on a phone the strip truncates, and losing the deadline off the
           end is worse than losing the sentence. Label + date must survive at every width. -->
      <span class="text-xs sm:text-sm font-semibold truncate">
        Prüfung fällig<span class="hidden sm:inline"> · Eine Ihrer Einreichungen muss überprüft werden</span>@if (banner().deadline) {<span> · fällig am {{ banner().deadline | date:'dd.MM.yyyy' }}</span>}
      </span>
    }
    <svg class="h-4 w-4 shrink-0 ml-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24"
         xmlns="http://www.w3.org/2000/svg">
      <path d="M9 5l7 7-7 7" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
    </svg>
  </a>
}

<div class="pt-14 standalone:pt-0 standalone:pb-20 lg:pt-0">
  <div
    (click)="sidebar = false"
    [ngClass]="{'pointer-events-auto opacity-50': sidebar}"
    class="fixed inset-x-0 bottom-0 top-14 cursor-pointer pointer-events-none opacity-0 lg:hidden bg-gray-900 transition-opacity z-[49]"></div>
  <div [ngClass]="{'translate-x-0': sidebar}"
       class="fixed top-14 left-0 bottom-0 w-64 -translate-x-full lg:translate-x-0 z-50">
    <app-sidebar [(open)]="sidebar"></app-sidebar>
  </div>
  <div [ngClass]="showsBanner ? 'top-24' : 'top-14'"
       class="fixed left-0 lg:left-64 bottom-0 right-0 standalone:!bottom-sb-12">
    <router-outlet></router-outlet>
  </div>
</div>

<!-- Installed-PWA bottom tab bar (Kalender / Arbeitszeiten / Profil / Mehr).
     `hidden standalone:grid` — `standalone:` is a display-mode media variant ((display-mode: standalone), see
     tailwind.config.js), so this bar renders ONLY inside an installed PWA. That is why a defect here is invisible
     in a normal browser tab and reaches users unnoticed (Bug #256).

     Two rules hold for all four icons, deliberately applied uniformly rather than per-tab:
     1. Every <svg> carries its OWN size class (h-8 w-8) and never relies on the h-8 w-8 wrapper to imply it.
        An <svg> with only a viewBox has no specified width/height, so its size is left to the browser's default
        sizing algorithm — the documented Bug #218 failure mode is that WebKit resolves that to 0x0, so the icon
        is missing in Safari while Chrome looks perfect. See docs/articles/frontend/style-guide.md ("Always give
        an icon its size class"); its styles.scss safety net is scoped to app-navbar-item-large/-small and does
        NOT reach this bar. All four icons were relying on the wrapper, so they are hardened to the documented
        rule. Measured 32x32 in WebKit and Chromium, before and after: no visual change, one less default relied
        on.
     2. Every icon paints with an explicit fill/stroke of `currentColor`, so it inherits the tab's own colour
        (text-gray-400, or text-theme-primary-700 via routerLinkActive) exactly like the tab's label does.
        The global `svg { fill: currentColor }` in styles.scss already does this implicitly, but stating it on
        the paths keeps the icon correct on its own and matches the style guide's icon rule. -->
<div
  class="fixed inset-x-0 bottom-0 h-sb-14 pb-safe-bottom hidden standalone:grid standalone:grid-cols-4 bg-white/90 backdrop-blur-md border-t border-gray-200/60 justify-around">
  <div [routerLinkActive]="['text-theme-primary-700']" [routerLink]="EmployeePanelRoutes.Calendar"
       class="flex flex-col h-16 p-2 text-gray-400">
    <div class="h-8 w-8 mx-auto">
      <svg class="h-8 w-8" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M16.5 5V3m-9 2V3M3.25 8h17.5M3 10.044c0-2.115 0-3.173.436-3.981a3.896 3.896 0 0 1 1.748-1.651C6.04 4 7.16 4 9.4 4h5.2c2.24 0 3.36 0 4.216.412c.753.362 1.364.94 1.748 1.65c.436.81.436 1.868.436 3.983v4.912c0 2.115 0 3.173-.436 3.981a3.896 3.896 0 0 1-1.748 1.651C17.96 21 16.84 21 14.6 21H9.4c-2.24 0-3.36 0-4.216-.412a3.896 3.896 0 0 1-1.748-1.65C3 18.128 3 17.07 3 14.955z"
          fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
          stroke-width="1.5"/>
      </svg>
    </div>
    <span class="mx-auto text-xs">Kalender</span>
  </div>
  <div [routerLinkActive]="['text-theme-primary-700']" [routerLink]="EmployeePanelRoutes.Shifts"
       class="flex flex-col h-16 p-2 text-gray-400">
    <div class="h-8 w-8 mx-auto">
      <svg class="h-8 w-8" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M28 51.906c13.055 0 23.906-10.828 23.906-23.906c0-13.055-10.828-23.906-23.883-23.906c-1.242 0-1.851.75-1.851 1.968v9.094c0 1.008.68 1.828 1.71 1.828c1.032 0 1.735-.82 1.735-1.828V8.148C39.93 8.968 47.898 17.5 47.898 28A19.84 19.84 0 0 1 28 47.922c-11.063 0-19.945-8.86-19.922-19.922c.023-4.922 1.781-9.398 4.711-12.844c.726-.914.773-2.015 0-2.836c-.774-.843-2.086-.773-2.93.282C6.273 16.773 4.094 22.164 4.094 28c0 13.078 10.828 23.906 23.906 23.906m3.75-20.297c1.851-1.922 1.477-4.547-.75-6.093l-12.4-8.649c-1.171-.82-2.39.399-1.57 1.57l8.649 12.399c1.547 2.227 4.171 2.625 6.07.773"
          fill="currentColor"/>
      </svg>
    </div>
    <span class="mx-auto text-xs">Arbeitszeiten</span>
  </div>
  <div [routerLinkActive]="['text-theme-primary-700']" [routerLink]="EmployeePanelRoutes.MyProfile"
       class="flex flex-col h-16 p-2 text-gray-400">
    <div class="h-8 w-8 mx-auto">
      <!-- Bug #256: this group used to carry Tailwind's `fill-none` (fill: none). `fill` is an INHERITED
           property and none of the paths declared a fill or a stroke of their own, so every path inherited
           `fill: none` and the whole icon painted nothing. Only the first path is the transparent 48x48
           bounding box that legitimately stays `none`; the two glyph paths must paint in `currentColor`. -->
      <svg class="h-8 w-8" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <g>
          <path d="M0 0h48v48H0z" fill="none"/>
          <path clip-rule="evenodd" d="M24 27a8 8 0 1 0 0-16a8 8 0 0 0 0 16m0-2a6 6 0 1 0 0-12a6 6 0 0 0 0 12"
                fill="currentColor" fill-rule="evenodd"/>
          <path clip-rule="evenodd"
                d="M44 24c0 11.046-8.954 20-20 20S4 35.046 4 24S12.954 4 24 4s20 8.954 20 20M33.63 39.21A17.9 17.9 0 0 1 24 42a17.9 17.9 0 0 1-9.831-2.92q-.36-.45-.73-.93A2.14 2.14 0 0 1 13 36.845c0-1.077.774-1.98 1.809-2.131c6.845-1 11.558-.914 18.412.035A2.08 2.08 0 0 1 35 36.818c0 .48-.165.946-.463 1.31q-.461.561-.907 1.082m3.355-2.744c-.16-1.872-1.581-3.434-3.49-3.698c-7.016-.971-11.92-1.064-18.975-.033c-1.92.28-3.335 1.856-3.503 3.733A17.94 17.94 0 0 1 6 24c0-9.941 8.059-18 18-18s18 8.059 18 18a17.94 17.94 0 0 1-5.015 12.466"
                fill="currentColor" fill-rule="evenodd"/>
        </g>
      </svg>
    </div>
    <span class="mx-auto text-xs">Profil</span>
  </div>
  <div (click)="sidebar = !sidebar" class="flex flex-col h-16 p-2 text-gray-400">
    <div class="h-8 w-8 mx-auto">
      <svg class="h-8 w-8" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7 10a1 1 0 1 1-2 0a1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0a1 1 0 0 1 2 0m4 0a1 1 0 1 1-2 0a1 1 0 0 1 2 0m-5-8a8 8 0 1 0 0 16a8 8 0 0 0 0-16m-7 8a7 7 0 1 1 14 0a7 7 0 0 1-14 0"
          fill="currentColor"/>
      </svg>
    </div>
    <span class="mx-auto text-xs">Mehr</span>
  </div>
</div>
